/**
 * Fenice Italy Business API
 * # Fenice Italy Business API  ## General Http Status: HTTP STATUS CODE | DESCRIPTION --- | --- 400 | Business error or general error 401 | Expired token 403 | Access token does not have the required scope 404 | Not found 500 | Internal error  ## Specific Error Codes: Verti has specific errors based on validations, in error field *code*  CODE | DESCRIPTION --- | --- KOIT001 | Plate not valid from SIC/SITA. KOIT002 | Vehicle plate number is not valid. KOIT003 | Login failed. Password is not correct.  ## Annotations:   - In those services that return a list of items, in the case of not found any of them, it will return an empty list.   - For date format, standard ISO 8601. (YYYY-MM-DDThh:mm:ss.sTZD)
 *
 * OpenAPI spec version: 1.2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ClientComplete } from './clientComplete';

export interface Participant {
  /**
   * Unique Id for the participant Figure
   */
  participantFigureId?: string;
  /**
   * Type of participant figure related to a policy or risk. E.g.: policyholder
   */
  participantFigureTypeCode?: Participant.ParticipantFigureTypeCodeEnum;
  /**
   * Type description of participant figure related to a policy or risk. E.g.: policyholder
   */
  participantFigureTypeDesc?: string;
  figurePersonalData?: ClientComplete;
  canUpdateAddress?: boolean;
}
export namespace Participant {
  export type ParticipantFigureTypeCodeEnum = 'NamedInsured' | 'Owner_Vrt' | 'PMIDriver_Vrt' | 'AccountHolder';
  export const ParticipantFigureTypeCodeEnum = {
    NamedInsured: 'NamedInsured' as ParticipantFigureTypeCodeEnum,
    OwnerVrt: 'Owner_Vrt' as ParticipantFigureTypeCodeEnum,
    PMIDriverVrt: 'PMIDriver_Vrt' as ParticipantFigureTypeCodeEnum,
    AccountHolder: 'AccountHolder' as ParticipantFigureTypeCodeEnum,
  };
}
